module.exports = __webpack_public_path__ + "img/modelzh_16.0c059507.jpg";